module.exports = __webpack_public_path__ + "static/media/09_nine_disable_Severe.22a22179.svg";